// src/utils/categoryTranslation.js

/**
 * 翻譯分類名稱
 * 
 * @param {string} category - 英文分類名稱（如 "Agarwood", "Board"）
 * @param {Function} t - i18n 翻譯函數
 * @returns {string} 翻譯後的分類名稱
 * 
 * 使用方式：
 * import { translateCategory } from '@/utils/categoryTranslation';
 * const translatedName = translateCategory('Agarwood', t);
 */
export const translateCategory = (category, t) => {
  if (!category) return category;
  
  // 嘗試從 i18n 翻譯檔中獲取翻譯
  const translationKey = `categories.${category}`;
  const translated = t(translationKey);
  
  // 如果翻譯成功（返回的不是 key 本身），則使用翻譯
  // 否則返回原始的分類名稱
  return translated !== translationKey ? translated : category;
};

/**
 * 批量翻譯分類名稱
 * 
 * @param {Array<string>} categories - 英文分類名稱陣列
 * @param {Function} t - i18n 翻譯函數
 * @returns {Array<string>} 翻譯後的分類名稱陣列
 */
export const translateCategories = (categories, t) => {
  if (!Array.isArray(categories)) return [];
  return categories.map(category => translateCategory(category, t));
};

/**
 * 獲取分類圖標
 * 
 * @param {string} category - 分類名稱
 * @returns {string} 分類圖標 emoji
 */
export const getCategoryIcon = (category) => {
  const iconMap = {
    'Agarwood': '🌿',
    'Board': '🪵'
  };
  return iconMap[category] || '📦';
};